import React from 'react';
import { Box, Skeleton } from '@mui/material';
import {
  ActionWrapper,
  HelperText,
  ProfileFormWrapper,
  ProfileImageBox,
  StaffFormInputWrapper,
  StaffFormWrapper,
  UploadButton
} from '../styled';

const StaffBasicFormSkeleton = () => {
  return (
    <StaffFormWrapper>
      <ProfileImageBox>
        <Skeleton variant='rectangular' width={120} height={120} />
        <UploadButton fullWidth>
          <Skeleton variant='text' width='80%' />
        </UploadButton>
        <HelperText>
          <Skeleton variant='text' width='100%' />
        </HelperText>
      </ProfileImageBox>
      <ProfileFormWrapper>
        <ActionWrapper>
          <Skeleton variant='rectangular' width={80} height={30} />
          <Skeleton variant='rectangular' width={100} height={30} />
        </ActionWrapper>
        <StaffFormInputWrapper>
          <Box>
            <Skeleton variant='text' width='40%' />
            <Skeleton variant='rectangular' height={56} />
          </Box>
          <Box>
            <Skeleton variant='text' width='40%' />
            <Skeleton variant='rectangular' height={56} />
          </Box>
          <Box>
            <Skeleton variant='text' width='40%' />
            <Skeleton variant='rectangular' height={56} />
          </Box>
        </StaffFormInputWrapper>
      </ProfileFormWrapper>
    </StaffFormWrapper>
  );
};

export default StaffBasicFormSkeleton;
